<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-50" cols="6">
        <v-row class="h-25">HTTP :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">
            {{ http | comma }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import { comma } from '@/utils/formatter';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';

export default {
  mixins: [instanceable, contextmenuable],
  data() {
    return {
      http: 0,
      contextmenuUrl: '/views/detailview/java/ut',
    };
  },
  methods: {
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // wsBufferedDataHandler(key, responses, every) {
    //   responses.forEach(response => every(key, response));
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
    wsDataHandler(key, response) {
      this.http = comma(parseInt(response[0]?.cnt || 0));
    },
  },
  created() {
    // BEGIN::Modified.by.KWShin.2025.11.29.
    // this.$websocket.realtime.send({
    //   requests: [
    //     {
    //       key: { name: 'rawJavaHttpSssn', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
    //       fields: ['stime'],
    //       empty: false,
    //       handler: {
    //         buffer: this.wsBufferedDataHandler,
    //         every: this.wsDataHandler,
    //       },
    //     },
    //   ],
    // });
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'cntJavaHttpSssn', sstmId: this.node.systemId, instId: this.node.instanceId, nodeId: this.node.id },
          fields: ['cnt'],
          empty: false,
          handler: {
            every: this.wsDataHandler,
          },
        },
      ],
    });
    // FINISH::Modified.by.KWShin.2025.11.29.
  },
};
</script>
